// Import necessary modules
import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpErrorResponse,
	HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

// Injectable decorator to allow this service to be injected into other components
@Injectable()
export class JWTInterceptor implements HttpInterceptor {
	// Constructor with the necessary services injected
	constructor(
		private accountService: AccountService,
		private notificationService: NotificationService
	) {}

	// Implement the intercept function which will be called for all http requests
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// Check if the current URL contains '/register', '/forgot-password', or '/login'
		const skipApiPaths = ['account/stripe/status'];
		if (skipApiPaths.some((path) => req.url.includes(path))) {
			return next.handle(req);
		}
		// Handle the request and continue to the next interceptor in the chain if any
		return next.handle(req).pipe(
			tap((event) => {
				if (event instanceof HttpResponse) {
					let errorCode = event?.body?.errors?.code || 0;

					if (
						errorCode == 1001 ||
						errorCode == 1002 ||
						errorCode == 1003 ||
						errorCode == 1004
					) {
						this.showJWTExpiredNotification();
						this.accountService.logout();
					}
				}
			}),
			catchError((error) => {
				this.showServerErrorNotification();
				// Handle the error here
				throw error; // Re-throw the error to propagate
			})
		);
	}

	/**
	 * This function shows a notification when the JWT token has expired.
	 * It uses the NotificationService to open the notification.
	 * Error handling is added to handle any potential errors when opening the notification.
	 */
	showJWTExpiredNotification(): void {
		try {
			// Define the message for the notification
			let expiredMessage = $localize`:@@edit_fundraiser_sessionExpired_notification:The session expired, you are logged out.`;

			// Use the NotificationService to open the notification
			this.notificationService.openNotificationIndefinite(
				expiredMessage,
				'OK',
				'error'
			);
		} catch (error) {
			// Log the error for debugging purposes
			console.error('Error while showing JWT expired notification:', error);
		}
	}

	/**
	 * This function shows a notification when there is a server error.
	 * It uses the NotificationService to open the notification.
	 * Error handling is added to handle any potential errors when opening the notification.
	 */
	showServerErrorNotification(): void {
		try {
			// Define the message for the notification
			let expiredMessage = $localize`:@@serverError_notification:There is an error in fetching your data. Kindly contact support.`;

			// Use the NotificationService to open the notification
			// this.notificationService.openNotificationIndefinite(
			// 	expiredMessage,
			// 	'OK',
			// 	'error'
			// );
		} catch (error) {
			// Log the error for debugging purposes
			console.error('Error fetching data:', error);
		}
	}
}
